import React, { useState, useEffect, Fragment } from "react";

import { Router } from "@reach/router";

import { Http } from "./Http";
import queryString from "query-string";

import { Spin, Result, message } from "antd";

import Container from "./pages/Container";
import Bridge from "./pages/Bridge";

import styles from "./App.module.less";

function App() {
  return (
    <div className={styles.App}>
      <Router>
        <Bridge path="bridge" />
        <PrivateRoute as={Container} path="/*" />
      </Router>
    </div>
  );
}

const PrivateRoute = ({ navigate, as: Component, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false);

  const getVerify = async () => {
    let para = queryString.stringify({});
    let parsed = await Http.get(`verify`, {
      earchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setAuth(true);
    }
  };

  const onLoading = async () => {
    setLoading(true);
    try {
      await getVerify();
    } catch (error) {
      await message.error("权限认证错误, 错误原因: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onLoading();
  }, []);

  const UnitLoad = () => {
    return (
      <div className={styles.waiting}>
        <Spin size="large" tip="加载中..." />
      </div>
    );
  };

  const UnitAuth = () => {
    return auth ? (
      <Component {...props} />
    ) : (
      <div className={styles.waiting}>
        <Result
          status="error"
          title="登陆过期"
          subTitle="请您返回中台再次尝试登陆, 如果还是登陆不上请联系客服"
        />
      </div>
    );
  };

  return <Fragment>{loading ? UnitLoad() : UnitAuth()}</Fragment>;
};

export default App;
